import { useGoogleAnalyticsTracking, useQuery } from "helpers/utils";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/ErrorBoundary";
import MainLayouts from "./layouts/MainLayouts";

// Log setelah semua import selesai
//console.log('🟡 [App.js] ===== App.js FILE LOADED =====');
//console.log('🟡 [App.js] File loaded at:', new Date().toISOString());
//console.log('🟡 [App.js] useGoogleAnalyticsTracking imported:', typeof useGoogleAnalyticsTracking);
//console.log('🟡 [App.js] useQuery imported:', typeof useQuery);
//console.log('🟡 [App.js] All imports completed');

function App() {
  //console.log('🟡 [App.js] ===== App Component Rendered =====');
  //console.log('🟡 [App.js] Component mounted at:', new Date().toISOString());

  const query = useQuery();
  const isDebug = query.debug;

  //console.log('🟡 [App.js] Query params:', query);
  //console.log('🟡 [App.js] isDebug:', isDebug);
  //console.log('🟡 [App.js] Current URL:', window.location.href);
  //console.log('🟡 [App.js] About to call useGoogleAnalyticsTracking()...');

  // Track Google Analytics parameters from URL
  try {
    useGoogleAnalyticsTracking();
    //console.log('🟡 [App.js] useGoogleAnalyticsTracking() called successfully');
  } catch (error) {
    console.error('🔴 [App.js] Error calling useGoogleAnalyticsTracking():', error);
  }

  return (
    <ErrorBoundary>
      <MainLayouts summary={true}>
        {isDebug === "1" && (
          <Container fluid>
            <Row>
              <Col lg={3} className="p-3">
                <Link to="/orderdomain">Domain</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderhosting">Hosting</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/ordervps">VPS</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderserver">Server</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderemailsuite">Email Suite</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/ordersignature">Digital Signature</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderdomainbackorder">Domain Backorder</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderdiegovpn">Diego VPN</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderssl">Order SSL</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/orderproduct">Other Product</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/migrasihosting">Migrasi Hosting</Link>
              </Col>
              {/* <Col lg={3} className="p-3">
                <Link to="/upgrade?serviceid=44696">Upgrade Service (with serviceid - Active)</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/upgrade?serviceid=44755">Upgrade Service (with serviceid - Pending)</Link>
              </Col> */}
              <Col lg={3} className="p-3">
                <Link to="/upgrade">Upgrade Service (list services)</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/renew">Renew Service</Link>
              </Col>
              <Col lg={3} className="p-3">
                <Link to="/addon">Addon Service</Link>
              </Col>
            </Row>
          </Container>
        )}
      </MainLayouts>
    </ErrorBoundary>
  );
}

export default App;
